export default "__VITE_ASSET__BbiAIaOx__"